import React, { useState, useEffect } from "react";
import VideoThumbnail from "react-video-thumbnail"; // for direct videos

const getYouTubeId = (url) => {
    const regex =
        /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
};

const getVimeoId = (url) => {
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? match[1] : null;
};

const UniversalVideoThumbnail = ({ videoUrl, width }) => {
    const [vimeoThumb, setVimeoThumb] = useState(null);
    const youTubeId = getYouTubeId(videoUrl);
    const vimeoId = getVimeoId(videoUrl);

    useEffect(() => {
        if (vimeoId) {
            fetch(`https://vimeo.com/api/v2/video/${vimeoId}.json`)
                .then((res) => res.json())
                .then((data) => setVimeoThumb(data[0]?.thumbnail_large));
        }
    }, [vimeoId]);

    if (youTubeId) {
        const ytThumb = `https://img.youtube.com/vi/${youTubeId}/hqdefault.jpg`;
        return <img src={ytThumb} alt="YouTube thumbnail" width={width} />;
    }

    if (vimeoThumb) {
        return <img src={vimeoThumb} alt="Vimeo thumbnail" width={width} />;
    }

    // fallback for direct video files like .mp4
    return <VideoThumbnail videoUrl={videoUrl} width={width} />;
};

export default UniversalVideoThumbnail;
